export const breakpoints = {
  xs: {
    down: '@media screen and (max-width: 479px)',
    up: '@media screen and (min-width: 480px)',
  },
  sm: {
    down: '@media screen and (max-width: 767px)',
    up: '@media screen and (min-width: 768px)',
  },
  md: {
    down: '@media screen and (max-width: 991px)',
    up: '@media screen and (min-width: 992px)',
  },
  lg: {
    down: '@media screen and (max-width: 1199px)',
    up: '@media screen and (min-width: 1200px)',
  },
  xl: {
    down: '@media screen and (max-width: 1599px)',
    up: '@media screen and (min-width: 1600px)',
  },
  vertical: {
    xs: {
      down: '@media screen and (max-height: 479px)',
      up: '@media screen and (min-height: 480px)',
    },
    sm: {
      down: '@media screen and (max-height: 767px)',
      up: '@media screen and (min-height: 768px)',
    },
    md: {
      down: '@media screen and (max-height: 991px)',
      up: '@media screen and (min-height: 992px)',
    },
    lg: {
      down: '@media screen and (max-height: 1199px)',
      up: '@media screen and (min-height: 1200px)',
    },
    xl: {
      down: '@media screen and (max-height: 1599px)',
      up: '@media screen and (min-height: 1600px)',
    },
  },
  combined: {
    xs: {
      down: '@media screen and (max-width: 479px) and (max-height: 479px)',
      up: '@media screen and (min-width: 480px) and (min-height: 480px)',
    },
    sm: {
      down: '@media screen and (max-width: 767px) and (max-height: 767px)',
      up: '@media screen and (min-width: 768px) and (min-height: 768px)',
    },
    md: {
      down: '@media screen and (max-width: 991px) and (max-height: 991px)',
      up: '@media screen and (min-width: 992px) and (min-height: 992px)',
    },
    lg: {
      down: '@media screen and (max-width: 1199px) and (max-height: 1199px)',
      up: '@media screen and (min-width: 1200px) and (min-height: 1200px)',
    },
    xl: {
      down: '@media screen and (max-width: 1599px) and (max-height: 1599px)',
      up: '@media screen and (min-width: 1600px) and (min-height: 1600px)',
    },
  },
};

export const colors = (mode = 'light') => ({
  vizred: '#D14F69',
  vizred50: '#F38DA1',
  vizred60: '#EFA8B6',
  vizredReduced: 'rgba(209,79,105,0.1)',
  vizgreen: '#81FFCA',
  vizgreenDark: '#108D90',
  vizgreenReduced: 'rgba(129,255,202,0.2)',
  vizblack: '#30242D',
  vizblackReduced: 'rgba(48,36,45,0.1)',
  vizgray: '#C4BBC1',

  errorRed: '#FF3232',
  bmGreen: '#4A7E3E',

  twitter: '#5eaade',
  facebook: '#4864bb',
  whatsapp: '#42aa42',

  marker: '#fffdc0',
  markerDark: '#FFD169',

  accent1: '#D14F4F',
  accent2: '#4C80BC',

  black: '#222',
  white: '#FFF',

  text: mode === 'light' ? '#222' : '#FFF',
  links: mode === 'light' ? '#3E77BF' : '#528BD3',
  focus: mode === 'light' ? 'rgba(62, 119, 191, 0.75)' : 'rgba(82, 139, 211, 0.75)',
  lightText: mode === 'light' ? '#676767' : '#A8A8A8',
  borders: mode === 'light' ? '#DDDDDD' : '#5E5E5E',
  background: mode === 'light' ? '#FFF' : '#222',
  backgroundShaded: mode === 'light' ? '#F9F9F9' : '#171717',

  grey25: '#424242',
  grey30: '#4F4F4F',
  grey35: '#5E5E5E',
  grey40: '#676767',
  grey45: '#767676',
  grey: '#767676',
  grey50: '#858585',
  grey60: '#969696',
  grey65: '#A8A8A8',
  grey75: '#C2C2C2',
  grey85: '#DDDDDD',
  grey95: '#F2F2F2',
  grey99: '#F9F9F9',

  red25: '#9E1B1B',
  red30: '#B32424',
  red35: '#BF3434',
  red40: '#CC3B3B',
  red45: '#D14F4F',
  red: '#D14F4F',
  red50: '#DB6060',
  red60: '#F26D6D',
  red65: '#FF8282',
  red75: '#FFA8A8',
  red85: '#FFCFCF',
  red95: '#FFECEC',
  red99: '#FFF5F5',

  blue25: '#154B8A',
  blue30: '#1E599E',
  blue35: '#2D67AB',
  blue: '#2D67AB',
  blue40: '#3872B5',
  blue45: '#4C80BC',
  blue50: '#5A8CC7',
  blue60: '#6B9EDB',
  blue65: '#83B0E5',
  blue75: '#A4C8F1',
  blue85: '#C9E2FF',
  blue95: '#EBF4FF',
  blue99: '#F7FAFF',

  purple25: '#8C1561',
  purple30: '#A11F71',
  purple35: '#AD2D7E',
  purple40: '#B83989',
  purple45: '#BF4D95',
  purple: '#BF4D95',
  purple50: '#C95BA1',
  purple60: '#DB6BB2',
  purple65: '#E583C1',
  purple75: '#F1A4D5',
  purple85: '#FFC9EB',
  purple95: '#FFEBF8',
  purple99: '#FFF7FC',

  green25: '#10612C',
  green30: '#157035',
  green35: '#268045',
  green: '#268045',
  green40: '#278F4B',
  green45: '#319E59',
  green50: '#39AD64',
  green60: '#4FBD75',
  green65: '#6FC98E',
  green75: '#93DBAC',
  green85: '#C0F0D0',
  green95: '#E3FAEB',
  green99: '#F5FFF9',

  yellow25: '#6B3B00',
  yellow30: '#784800',
  yellow35: '#8C5900',
  yellow40: '#966400',
  yellow45: '#A37200',
  yellow50: '#B38300',
  yellow60: '#C99400',
  yellow65: '#DBA718',
  yellow75: '#EDC147',
  yellow: '#EDC147',
  yellow85: '#FFDE85',
  yellow95: '#FFF1CC',
  yellow99: '#FFFBF0',
});

export const parties = {
  union: '#373737',
  unionMax: '#2d2d2d',
  unionMin: '#d8d8d8',
  spd: '#DB4240',
  spdMax: '#bf252c',
  spdMin: '#ffe3e1',
  linke: '#96276E',
  linkeMax: '#7d0358',
  linkeMin: '#fad5ed',
  gruene: '#4BA345',
  grueneMax: '#308b2f',
  grueneMin: '#d6f3d4',
  fdp: '#F6BB00',
  fdpMax: '#daa300',
  fdpMin: '#fff7ce',
  afd: '#34A3D2',
  afdMax: '#008bb9',
  afdMin: '#cff6ff',
  sonstige: '#888888',
  sonstigeMax: '#737373',
  sonstigeMin: '#f3f3f3',
  other: '#129B93',
  otherMax: '#00837c',
  otherMin: '#caf7f5',
  piraten: '#E9872A',
  piratenMax: '#cd700c',
  piratenMin: '#fbebdb',
  nichtwaehler: '#6C7D97',
  nichtwaehlerMax: '#566780',
  nichtwaehlerMin: '#e4e8ec',
};

export const font = {
  family: {
    serif: 'font-family: Georgia, serif;',
    sans: 'font-family: Roboto, Helvetica, Arial, sans-serif;',
    condensed: 'font-family: "Roboto Condensed", Roboto, Helvetica, Arial, sans-serif;',
  },
  size: {
    tiny: `
      font-size: 11px;
      line-height: 1.3;
      ${breakpoints.xs.up} {
        font-size: 12px;
      }
      ${breakpoints.sm.up} {
        font-size: 13px;
      }
    `,
    small: `
      font-size: 13px;
      line-height: 1.4;
      ${breakpoints.xs.up} {
        font-size: 14px;
      }
      ${breakpoints.sm.up} {
        font-size: 16px;
      }
    `,
    regular: `
      font-size: 15px;
      line-height: 1.6;
      ${breakpoints.xs.up} {
        font-size: 16px;
      }
      ${breakpoints.sm.up} {
        font-size: 19px;
      }
    `,
    large: `
      font-size: 20px;
      line-height: 1.2;
      ${breakpoints.xs.up} {
        font-size: 22px;
      }
      ${breakpoints.sm.up} {
        font-size: 28px;
      }
    `,
    huge: `
      font-size: 28px;
      line-height: 1.1;
      ${breakpoints.xs.up} {
        font-size: 32px;
      }
      ${breakpoints.sm.up} {
        font-size: 40px;
      }
    `,
  },
};

export const transitions = {
  hover: '100ms ease-out',
};

export const snippets = {
  resetButton: `
    appearance: none;
    cursor: pointer;
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    color: inherit;
    font: inherit;
    line-height: normal;
    font-smoothing: inherit;
  `,
};

export const margins = `
  margin: 12px auto;

  ${breakpoints.vertical.xs.up} {
    margin-top: 16px;
    margin-bottom: 16px;
  }
  ${breakpoints.vertical.sm.up} {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  ${breakpoints.vertical.md.up} {
    margin-top: 36px;
    margin-bottom: 36px;
  }
  ${breakpoints.vertical.lg.up} {
    margin-top: 48px;
    margin-bottom: 48px;
  }
`;

export const paddings = `
  padding-left: 16px;
  padding-right: 16px;

  ${breakpoints.xs.up} {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

export const layouts = {
  text: `
    position: relative;
    ${paddings}
    margin: 24px auto;
    max-width: 680px;
  `,
  small: `
    position: relative;
    ${margins}
    ${paddings}
    max-width: 800px;
  `,
  large: `
    position: relative;
    ${margins}
    ${paddings}
    max-width: 1120px;
  `,
  huge: `
    position: relative;
    ${margins}
    ${paddings}
    max-width: 1640px;
  `,
  full: `
    position: relative;
    ${margins}
    padding: 0;
  `,
  sidebar: {
    right: `
      ${paddings}
      padding-top: 24px;
      padding-bottom: 24px;
      margin: 24px 0;

      ${breakpoints.xs.up} {
        float: right;
        width: 220px;
        padding: 24px 0px;
        margin: 0 24px;
      }
      ${breakpoints.sm.up} {
        width: 240px;
        margin-right: calc(50% - 20px - 680px / 2);
      }
      ${breakpoints.md.up} {
        width: 280px;
        margin-right: calc(50% - 140px - 680px / 2);
      }
      ${breakpoints.lg.up} {
        width: 320px;
        margin-right: calc(50% - 160px - 680px / 2);
      }
      ${breakpoints.xl.up} {
        margin-right: calc(50% - 200px - 680px / 2);
      }
    `,
  },
};

export default function getTheme(mode = 'light') {
  return {
    mode,
    name: mode === 'light' ? 'Hell' : 'Dunkel',
    breakpoints,
    font,
    transitions,
    colors: colors(mode),
    parties,
    snippets,
    margins,
    paddings,
    layouts,
  };
}
